import { Loader2, Plus, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import LearnMoreButton from "@/components/learn/LearnMoreButton";
import { VoicePlaygroundHeaderProps } from "@/types/voice/voice-playground";
import { GenieIcon } from "@/components/ui/genie-icons/GenieIcon";

export const VoicePlaygroundHeader = ({
  onRefresh,
  isRefreshing,
  onCreateVoice,
}: VoicePlaygroundHeaderProps) => {
  return (
    <div className="flex items-center mb-8">
      <GenieIcon
        name="microphone"
        size={28}
        label="Voice Playground"
        className="h-7 w-7 md:h-8 md:w-8 mr-3 md:mr-4"
      />
      <div className="flex-1">
        <h1 className="text-3xl font-bold text-[#222B45]">Voice Playground</h1>
        <p className="text-genie-text-sub mt-1">
          Explore and test different voices for your Help Genie. Listen to samples and find the perfect voice for your brand.
        </p>
      </div>
      <div className="flex items-center gap-2">
        <Button
          onClick={onCreateVoice}
          className="bg-gradient-to-r from-genie-primary to-genie-secondary hover:from-genie-primary-hover hover:to-genie-secondary text-white font-semibold px-5 py-2.5 shadow-lg shadow-genie-primary/30 hover:shadow-xl hover:shadow-genie-primary/40 hover:scale-105 transition-all duration-200"
        >
          <Plus className="h-4 w-4 mr-2" />
          Create a Voice
        </Button>
        <Button onClick={onRefresh} disabled={isRefreshing} variant="outline" size="sm">
          {isRefreshing ? <Loader2 className="h-4 w-4 animate-spin" /> : <RefreshCw className="h-4 w-4" />}
          <span className="ml-2">Refresh</span>
        </Button>
        <LearnMoreButton topic="voice-playground" />
      </div>
    </div>
  );
};

export default VoicePlaygroundHeader;